// Histórico de edição (desfazer / refazer) do simulador 2D e 3D.
//
// Um plugin do Vuex observa as mutações do módulo "simulator" e compara uma foto (snapshot) do
// conteúdo editável da simulação. Alterações seguidas (ex.: arrastar uma geometria, digitar um
// valor) são agrupadas num único passo: a foto só é registrada depois de HISTORY_DEBOUNCE_MS sem
// mudanças. Mudanças de seleção, zoom, carregamento etc. não alteram a foto e não entram no histórico.
import { setCoordinates } from "./cellOptions";

const HISTORY_LIMIT = 50;
const HISTORY_DEBOUNCE_MS = 400;

// Campos que o usuário edita e que são salvos no backend
const FIELDS = [
  "GeometryList", "SourcesList", "FluxList", "cell", "default_material", "coordinates",
  "resolution", "until", "pml", "boundary", "decayThreshold", "quality3d", "title", "description"
];

export const takeSnapshot = (state) => JSON.stringify(
  FIELDS.reduce((snapshot, field) => ({ ...snapshot, [field]: state[field] }), {})
);

export const applySnapshot = (state, snapshot) => {
  const data = JSON.parse(snapshot);
  FIELDS.forEach((field) => {
    if (data[field] !== undefined) state[field] = data[field];
  });
  if (state.plotOptions) state.plotOptions.until = state.until;
  // A escala do canvas (px/µm) depende do tamanho da célula
  if (!state.is3d && data.coordinates) setCoordinates(state, data.coordinates);
  // A seleção pode apontar para um objeto que não existe mais
  const tokens = [...state.GeometryList, ...state.SourcesList, ...state.FluxList].map(item => item.token);
  if (state.selectedToken && !tokens.includes(state.selectedToken)) state.selectedToken = "";
};

// Mutações do próprio histórico e as que carregam outra simulação (zeram o histórico)
const HISTORY_MUTATIONS = ["historyPush", "historyUndo", "historyRedo", "historyReset"];
const LOAD_MUTATIONS = ["setState", "set3dState"];

export const historyLimit = HISTORY_LIMIT;

export const createHistoryPlugin = (namespace = "simulator") => (store) => {
  let baseline = null;
  let timer = null;
  const state = () => store.state[namespace];

  const flush = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (baseline === null) return;
    const now = takeSnapshot(state());
    if (now !== baseline) {
      store.commit(`${namespace}/historyPush`, baseline);
      baseline = now;
    }
  };

  // As ações de desfazer/refazer chamam flush antes, para não perder a última edição
  store.historyFlush = flush;

  store.subscribe(({ type }) => {
    if (!type.startsWith(`${namespace}/`)) return;
    const name = type.slice(namespace.length + 1);
    if (LOAD_MUTATIONS.includes(name)) {
      clearTimeout(timer);
      timer = null;
      store.commit(`${namespace}/historyReset`);
      baseline = takeSnapshot(state());
      return;
    }
    if (HISTORY_MUTATIONS.includes(name)) {
      if (name !== "historyPush") baseline = takeSnapshot(state());
      return;
    }
    if (baseline === null) return;
    clearTimeout(timer);
    timer = setTimeout(flush, HISTORY_DEBOUNCE_MS);
  });
};
